import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage';
import CoursePage from './pages/CoursePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import CareerResultsPage from './pages/CareerResultsPage';
import CourseSuccessPage from './pages/CourseSuccessPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/course" element={<CoursePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund" element={<RefundPage />} />
        <Route path="/career-results" element={<CareerResultsPage />} />
        <Route path="/career-result" element={<CareerResultsPage />} />
        <Route path="/course/success" element={<CourseSuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
